/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Injectable } from '@angular/core';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { TabService } from './../../core/services/tab.service';

/**
 * @export
 * @class CanActivateService
 * @implements {CanActivate}
 */
@Injectable()
export class CanActivateService  {

  constructor(private lmsModuleService: LmsModuleService,
    private tabService: TabService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const tab = this.tabService.getTabById(Math.abs(route.params['tabid']))[0];
    return true;
  }
}
